import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    brand: {
        fontFamily: 'Chronicle, "Open Sans", sans-serif',
        textTransform: 'uppercase',
        fontSize: '0.8rem',
        fontWeight: 400,
        letterSpacing: 0,
        lineHeight: 1,
        marginBottom: '0.5rem',
        fontSmoothing: 'auto',
        color: 'inherit',
    },
}), { name: 'BrandName' });

export default function BrandName({name}) {
    const classes = useStyles();
    return <>
        <div className={classes.brand}>
            {name}
        </div>
    </>;
}
